if (!customElements.get('kes-purchase')) {
  customElements.define('kes-purchase', class extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.root = this.closest('product-info');
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.frequency = this.querySelector('[data-frequency]');
      this.input = this.querySelector('[data-plan-input]');
      this.once = this.querySelector('input[value="once"]');
      this.sub = this.querySelector('input[value="subscribe"]');
      this.button = this.form.querySelector('[name="add"]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.data.currency});
      this.change = e => {
        if(e.target.name === 'id') this.selectVariant();
        else if(e.target.name === 'quantity' || this.contains(e.target)) this.update();
      };
      this.root.addEventListener('change',this.change);
      if(typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, e => {
        if(e.data.sectionId === this.dataset.section) this.selectVariant();
      });
      this.querySelector('[data-mobile-buy]').addEventListener('click',()=>this.button.click());
      this.bar = () => {
        this.querySelector('.kes-mobile-purchase').hidden = !(matchMedia('(max-width:749px)').matches && this.button.getBoundingClientRect().bottom < 0);
        this.querySelector('[data-mobile-buy]').disabled = this.button.disabled;
      };
      this.observer = new IntersectionObserver(this.bar);
      this.observer.observe(this.button);
      window.addEventListener('resize',this.bar);
      this.selectVariant();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('change',this.change);
      this.unsubscribe?.();this.observer?.disconnect();window.removeEventListener('resize',this.bar);
    }
    selectVariant() {
      this.variant = this.data.variants.find(v=>String(v.id)===this.form.querySelector('[name="id"]').value);
      if(!this.variant) {this.input.disabled=true;return;}
      const old=this.frequency.value;
      this.frequency.replaceChildren(...this.variant.plans.map(p=>new Option(p.name,String(p.id))));
      if(this.variant.plans.some(p=>String(p.id)===old)) this.frequency.value=old;
      const hasPlans=this.variant.plans.length>0;
      this.querySelector('fieldset').hidden=!hasPlans;
      this.querySelector('.kes-sub-help').hidden=!hasPlans;
      if(!hasPlans)this.once.checked=true;
      this.once.closest('label').hidden=this.dataset.required==='true';
      if(this.dataset.required==='true'&&hasPlans)this.sub.checked=true;
      this.update();
    }
    update() {
      if(!this.variant)return;
      const specifications=this.root.querySelector('[data-specifications]');
      if(specifications){
        const pack=specifications.querySelector('[data-spec-pack]');
        if(pack)pack.textContent=this.variant.title;
        const upc=specifications.querySelector('[data-spec-upc]');
        if(upc)upc.textContent=this.variant.barcode||'';
        const row=specifications.querySelector('[data-spec-upc-row]');
        if(row)row.hidden=!this.variant.barcode;
      }
      const plan=this.variant.plans.find(p=>String(p.id)===this.frequency.value);
      const subscribed=this.sub.checked&&!!plan;
      this.input.disabled=!subscribed;this.input.value=subscribed?plan.id:'';
      this.querySelector('[data-frequency-box]').hidden=!subscribed;
      this.querySelector('[data-once-price]').textContent=this.money.format(this.variant.price/100);
      if(plan){
        this.querySelector('[data-sub-price]').textContent=this.money.format(plan.price/100);
        const saving=this.variant.price-plan.price;
        this.querySelector('[data-savings]').textContent=saving>0?this.dataset.saveLabel+' '+this.money.format(saving/100)+' ('+Math.round(saving/this.variant.price*100)+'%)':'';
      }
      const quantity=Number(this.root.querySelector('[name="quantity"]')?.value||1);
      const price=subscribed?plan.price:this.variant.price;
      const amount=this.money.format(quantity*price/100);
      this.querySelector('.kes-total').textContent=amount+' '+(subscribed?this.dataset.deliveryLabel:this.dataset.totalLabel);
      const label=subscribed?this.dataset.subLabel:this.dataset.addLabel;
      if(this.variant.available&&!this.button.disabled)this.button.querySelector('span').textContent=label;
      this.querySelector('[data-mobile-price]').textContent=amount+(subscribed?' / '+this.dataset.deliveryLabel:'');
      this.querySelector('[data-mobile-buy]').textContent=label;
      this.querySelector('[data-mobile-buy]').disabled=this.button.disabled;
      const mainPrice=this.root.querySelector('.price-item--sale')||this.root.querySelector('.price__regular .price-item--regular');
      if(mainPrice)mainPrice.textContent=this.money.format(price/100);
      let context=this.root.querySelector('.kes-price-context');
      if(!context){context=document.createElement('p');context.className='kes-price-context';this.root.querySelector('[id^="price-"]')?.before(context);}
      context.textContent=subscribed?this.dataset.deliveryLabel:'';
      context.hidden=!subscribed;
    }
  });
}

